export function shouldResetSpatiusPrimarySessionBeforeConnect(
  shouldUseSpatiusPrimaryRoom: boolean
) {
  return !shouldUseSpatiusPrimaryRoom;
}

export function shouldKeepSpatiusPrimarySessionOnFallback(reason: "error" | "timeout") {
  return reason === "timeout";
}

export function normalizeAvatarProvider(configuredAvatarProvider: string | null | undefined) {
  const provider = (configuredAvatarProvider || "").trim().toLowerCase();
  return provider === "spatialreal" ? "spatius" : provider;
}

export function isSpatiusProvider(configuredAvatarProvider: string | null | undefined) {
  return normalizeAvatarProvider(configuredAvatarProvider) === "spatius";
}

export function isSpatiusAvatarIdentity(identity: string | null | undefined) {
  return Boolean(identity?.startsWith("spatius-avatar"));
}

export function shouldSubscribeSpatiusBaseRoomPublication({
  participantIdentity,
  publicationKind,
}: {
  participantIdentity: string | null | undefined;
  publicationKind: unknown;
}) {
  // In Spatius mode, the avatar participant republishes the audible tutor
  // audio. Dropping this base-room subscription makes the session silent.
  return isSpatiusAvatarIdentity(participantIdentity) && publicationKind === "audio";
}

export function shouldSubscribeSpatiusViewerPublication({
  participantIdentity,
  publicationKind,
}: {
  participantIdentity: string | null | undefined;
  publicationKind: unknown;
}) {
  // The separate Spatius viewer room owns visual playback only. Tutor audio is
  // rendered from the base lesson room to avoid duplicate, near-synchronized audio.
  return isSpatiusAvatarIdentity(participantIdentity) && publicationKind === "video";
}
